import { CardActionArea, CardContent } from '@material-ui/core';
import { ColorDynamic, Inline, Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import styled from 'styled-components';
import { PostingDTO } from '../../data/dto/PostingDTO';
import { PostingPricePerMile } from '../postings/PostingPricePerMile';
import { PostingVehicle } from '../postings/PostingVehicle';
import { PostingWaypoints } from '../postings/PostingWaypoints';

const Wrapper = styled(CardActionArea)`
  height: 100%;
  align-items: flex-start;

  border: 1px solid ${ColorDynamic.Silver400};
  border-radius: 4px;
  background-color: ${ColorDynamic.White};
`;

interface NearbyShipperLoadCardProps {
  posting: PostingDTO;
  onClick: () => void;
}

export function NearbyShipperLoadCard({
  posting,
  onClick,
}: NearbyShipperLoadCardProps) {
  const { load } = posting;
  const [firstVehicle] = load.vehicles;
  const restVehiclesCount = load.vehicles.length - 1;

  return (
    <Wrapper data-testid="NearbyShipperLoadCard" onClick={onClick}>
      <CardContent>
        <Stack space="xsmall">
          <Inline space="xxsmall" verticalAlign="bottom" noWrap={true}>
            <TextBox variant="heading-3">
              {formatCurrency(load.price, { minimumFractionDigits: 0 })}
            </TextBox>

            <PostingPricePerMile pricePerKm={load.price_per_km} />
          </Inline>

          <PostingWaypoints load={load} />

          {!!firstVehicle && (
            <Stack space="none">
              <PostingVehicle
                vehicle={firstVehicle}
                transportType={load.transport_type}
                hideVehicleInfo={!!load.hide_vehicle_info}
              />

              {restVehiclesCount > 0 && (
                <TextBox color="secondary">+{restVehiclesCount} more</TextBox>
              )}
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Wrapper>
  );
}
